import { NotifyIntent, NotifyOptions } from '@2wunder/klarx-tool'
import { message } from 'antd'
import { NotificationPlacement } from 'antd/es/notification'

import { ErrorType } from './contexts/types'

type AntdNotifyOptions = Partial<{
  maxCount: number
}>

export const notify = (options: NotifyOptions<AntdNotifyOptions>) => {
  const { type, ...config } = AntdNotifyAdapter(options)

  message[type](config)
}

const AntdNotifyAdapter = (options: NotifyOptions<AntdNotifyOptions>) => {
  return {
    type: INTENT_MAP[options.intent] || DEFAULT_ATTRIBUTES['intent'],
    placement: options.position || DEFAULT_ATTRIBUTES['placement'],
    duration: options.timeout || DEFAULT_ATTRIBUTES['timeout'],
    maxCount: options.additionalOptions?.maxCount,
    content: options.message,
    className: options.className || DEFAULT_ATTRIBUTES['className'],
    onClose: options.onDismiss
  }
}

const DEFAULT_ATTRIBUTES = {
  intent: 'error' as ErrorType,
  placement: 'bottomRight' as NotificationPlacement,
  timeout: 5,
  top: 0,
  bottom: 0,
  className: ''
}

const INTENT_MAP: Record<NotifyIntent, ErrorType> = {
  success: 'success',
  danger: 'error',
  warning: 'warning',
  info: 'info'
}
